import { Button, Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import React, { useState } from "react";
import SharedTitle from "../Components/SharedForms/SharedTitle";
import { FT_ENVIAR_1, FT_ENVIAR_2, FT_ENVIAR_3, FT_ENVIAR_4, FT_ENVIAR_5, TEXT_COLOR_FT } from "config/config";
import ConfirmDialog from "@jumbo/components/Common/ConfirmDialog";
import { enviarFichaTecnica } from "services/api";

import { useHistory } from 'react-router-dom';
import { CustomToast, toast } from "@jumbo/components/custom/Toast";
import { Send } from "@material-ui/icons";
import IconsSend from "icons/IconsSend";

const EnviarFt = props => {

    const [checked, setChecked] = useState(false);
    const [showModal, setShowModal] = useState(false)
    let history = useHistory();

    const closeModal = () => {
        setShowModal(false)
    }

    const handleChange = () => {
        setChecked(!checked);
    };

    const sendFicha = () => {

        enviarFichaTecnica(sessionStorage.getItem("idFicha"))
            .then(res => {
                toast.success("Ficha técnica enviada con éxito")
                history.push("/fichas_tecnicas")

            })
            .catch(e => {
                toast.error("Ocurrió un error al enviar la ficha técnica")
                console.error(e)
            })
            .finally(f => {
                console.log('en el finally')
            })
    }

    return (
        <div style={{
            marginBottom: 5,
            color: TEXT_COLOR_FT,
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        }}>
            <div>
                <SharedTitle title={'Enviar ficha técnica'} />

                <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom: 15, paddingLeft:25, paddingRight:25 }}>
                    <Grid container item xs={12}>
                        <p>{FT_ENVIAR_1}</p>
                    </Grid>
                    <br></br>
                    <Grid item xs={12}>
                        <span>
                            <p style={{ display: "inline" }}>{FT_ENVIAR_2}</p>
                            <p style={{ display: "inline", fontWeight: "bold" }}>{FT_ENVIAR_3}</p>
                            <p style={{ display: "inline" }}>{FT_ENVIAR_4}</p>
                        </span>
                    </Grid>
                    <br></br>
                    <Grid container item xs={12}>
                        <p>{FT_ENVIAR_5}</p>
                    </Grid>

                </Grid>
            </div>


            <Grid
                container item
                direction="column"
                style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: 15 }}
            >
                <Grid container item justifyContent="center">
                    <Grid item xs={3} style={{marginLeft:140}}>
                        <FormControlLabel
                            label="Acepto"
                            control={
                                <Checkbox checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
                            }
                        />
                    </Grid>
                </Grid>

                <Grid container item justifyContent="center">
                    <Grid item xs={3}>
                        <Button
                            startIcon={<IconsSend />}
                            disabled={!checked}
                            variant="outlined"
                            color="primary"
                            onClick={() => { setShowModal(true) }}
                        >
                           {/*  <Send style={{marginRight:10}}/> */}
                            Enviar Ficha Técnica
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <ConfirmDialog
                open={showModal}
                onClose={closeModal}
                title={"Enviar Ficha Técnica"}
                content={"¿Está seguro que desea enviar la información actual?"}
                btnLabels={{ confirm: "Aceptar", cancel: "Cancelar" }}
                onConfirm={sendFicha}
            />
            <CustomToast />
        </div>
    )

}


export default EnviarFt